import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['form']

    connect() {
        setTimeout(() => {
            this.element.focus()
            this.element.click()
        }, 15)
    }
}
